// eslint-disable-next-line
import * as React from 'react';
import { styled } from '@mui/styles';
import { Grid } from '@mui/material';

export const StyledGridCell = styled(Grid)({
    paddingLeft:15,
    paddingRight:15,
    marginBottom:10
})